/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummaryDepartmentsInner } from './vacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummaryDepartmentsInner';


export interface VacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummary { 
    departments?: Array<VacancyKpiReportControllerGetVacanciesReport200ResponseDataDepartmentSummaryDepartmentsInner>;
    totalInitial?: number;
    totalHires?: number;
    totalTerminations?: number;
    activeEmployees?: number;
}

